import base64 from 'base-64'
import Cookies from 'js-cookie'

export const TOKEN = 'token'
export const EXPIRES_ON = 'expires_on'
export const EXPIRES_DATE = 'expires_date'
export const USER_ID = 'user_id'
export const FULL_NAME = "fullname"
export const ROLE = "role"
export const EMAIL = "email"
export const O365_TOKEN = "o365_token"
export const USER_IMAGE = "user_image"
export const IS_NPI_ADMIN = "is_npi_admin"
export const IS_ADMIN = "is_admin"

export const SALE_SEARCH_STATUS = "sale_search_status"
export const SALE_SEARCH_PRIORITY = "sale_search_priority"
export const SALE_SEARCH_TEXT = "sale_search_text"
export const SALE_SEARCH_API = "sale_search_api"
export const SALE_SEARCH_CUSTOMER = "sale_search_customer"

export const TUBE_SEARCH_STATUS = "tube_search_status"
export const TUBE_SEARCH_PRIORITY = "tube_search_priority"
export const TUBE_SEARCH_TEXT = "tube_search_text"
export const TUBE_SEARCH_API = "tube_search_api"
export const TUBE_SEARCH_CUSTOMER = "tube_search_customer"

export const ACC_SEARCH_STATUS = "acc_search_status"
export const ACC_SEARCH_PRIORITY = "acc_search_priority"
export const ACC_SEARCH_TEXT = "acc_search_text"
export const ACC_SEARCH_API = "acc_search_api"
export const ACC_SEARCH_CUSTOMER = "acc_search_customer"
export const ACC_SEARCH_TYPE = "acc_search_type"

export const IS_NPI = "is_npi"
export const IS_PLANNING = "is_planning"
export const IS_SALE = "is_sale"

export const URL_INCOMING = "url_incoming"

function getCookie(key) {
    try {
        const value = Cookies.get(key)
        let setValue = ''
        
        if (value && typeof value === 'string') {
            setValue = base64.decode(value)
        }
        return setValue
    } catch (error) {
        return null
    }

}

function setCookie(key, value, expires) {
    const valueToString = String(value)
    let setValue = ''
    if (typeof valueToString === 'string') {
        setValue = base64.encode(valueToString)
    }
    if (expires && typeof expires === "number" && expires > 0) {
        Cookies.set(key, setValue, { expires: expires })
    } else {
        Cookies.set(key, setValue)
    }

}

function removeCookie(key) {
    Cookies.remove(key)
}

export function authentication(dataAuth, isRemember) {
    const { user: { email, fullName, id, isNpiAdmin, isAdmin, isNpi, isPlanning, isSale }, token, expiresDate, expiresOn } = dataAuth

    clearToken()
    setCookie(FULL_NAME, fullName)
    setCookie(EMAIL, email)
    setCookie(USER_ID, id)

    setCookie(TOKEN, token)
    setCookie(EXPIRES_DATE, expiresDate)
    setCookie(EXPIRES_ON, expiresOn)
    setCookie(IS_NPI_ADMIN, isNpiAdmin)
    setCookie(IS_ADMIN, isAdmin)
    setCookie(IS_NPI, isNpi)
    setCookie(IS_PLANNING, isPlanning)
    setCookie(IS_SALE, isSale)
}
export function setO365TokenCookie(data) {
    setCookie(O365_TOKEN, data)
}
export function getO365Token() {
    return getCookie(O365_TOKEN)
}

export function setUserImageCookie(data) {
    setCookie(USER_IMAGE, data)
}
export function getUserImageCookie() {
    return getCookie(USER_IMAGE)
}
export function clearToken() {
    removeCookie(TOKEN)
    removeCookie(EXPIRES_DATE)
    removeCookie(USER_ID)
    removeCookie(FULL_NAME)
    removeCookie(EMAIL)
    removeCookie(IS_ADMIN)
    removeCookie(IS_NPI_ADMIN)
    removeCookie(IS_NPI)
    removeCookie(IS_PLANNING)
    removeCookie(IS_SALE)
}

export function getAllCookies() {
    console.log('test fff getAllCookies')
    return {
        [TOKEN]: getCookie(TOKEN),
        [EXPIRES_ON]: getCookie(EXPIRES_ON),
        [EXPIRES_DATE]: getCookie(EXPIRES_DATE),
        [USER_ID]: getCookie(USER_ID),
        [IS_NPI_ADMIN]: getCookie(IS_NPI_ADMIN),
        [IS_ADMIN]: getCookie(IS_ADMIN),
        [FULL_NAME]: getCookie(FULL_NAME)
    }
}

export function getToken() {
    return getCookie(TOKEN)
}

export function getFullName() {
    return getCookie(FULL_NAME)
}

export function getRole() {
    return getCookie(ROLE)
}

export function getExpireDate() {
    return getCookie(EXPIRES_DATE)
}

export function getIsNpiAdmin() {
    return getCookie(IS_NPI_ADMIN)
}

export function getIsAdmin() {
    return getCookie(IS_ADMIN)
}

export function setSearchCookie(data) {
    const { priorityCode, statusCode, searchText, searchAPI, searchCustomer } = data
    clearSearchCookie()
    setCookie(SALE_SEARCH_STATUS, statusCode)
    setCookie(SALE_SEARCH_PRIORITY, priorityCode)
    setCookie(SALE_SEARCH_TEXT, searchText)
    setCookie(SALE_SEARCH_API, searchAPI)
    setCookie(SALE_SEARCH_CUSTOMER, searchCustomer)
}

export function getSearchCookie() {
    return {
        [SALE_SEARCH_STATUS]: getCookie(SALE_SEARCH_STATUS),
        [SALE_SEARCH_PRIORITY]: getCookie(SALE_SEARCH_PRIORITY),
        [SALE_SEARCH_TEXT]: getCookie(SALE_SEARCH_TEXT),
        [SALE_SEARCH_API]: getCookie(SALE_SEARCH_API),
        [SALE_SEARCH_CUSTOMER]: getCookie(SALE_SEARCH_CUSTOMER),
    }
}

export function clearSearchCookie() {
    removeCookie(SALE_SEARCH_STATUS)
    removeCookie(SALE_SEARCH_PRIORITY)
    removeCookie(SALE_SEARCH_TEXT)
    removeCookie(SALE_SEARCH_API)
    removeCookie(SALE_SEARCH_CUSTOMER)
}

export function setTubeSearchCookie(data) {
    const { priorityCode, statusCode, searchText, searchAPI, searchCustomer } = data
    clearSearchCookie()
    setCookie(TUBE_SEARCH_STATUS, statusCode)
    setCookie(TUBE_SEARCH_PRIORITY, priorityCode)
    setCookie(TUBE_SEARCH_TEXT, searchText)
    setCookie(TUBE_SEARCH_API, searchAPI)
    setCookie(TUBE_SEARCH_CUSTOMER, searchCustomer)
}

export function getTubeSearchCookie() {
    return {
        [TUBE_SEARCH_STATUS]: getCookie(TUBE_SEARCH_STATUS),
        [TUBE_SEARCH_PRIORITY]: getCookie(TUBE_SEARCH_PRIORITY),
        [TUBE_SEARCH_TEXT]: getCookie(TUBE_SEARCH_TEXT),
        [TUBE_SEARCH_API]: getCookie(TUBE_SEARCH_API),
        [TUBE_SEARCH_CUSTOMER]: getCookie(TUBE_SEARCH_CUSTOMER),
    }
}

export function clearTubeSearchCookie() {
    removeCookie(TUBE_SEARCH_STATUS)
    removeCookie(TUBE_SEARCH_PRIORITY)
    removeCookie(TUBE_SEARCH_TEXT)
    removeCookie(TUBE_SEARCH_API)
    removeCookie(TUBE_SEARCH_CUSTOMER)
}

export function setAccSearchCookie(data) {
    const { priorityCode, statusCode, searchText, searchAPI, searchCustomer, searchTypeAcc } = data
    clearSearchCookie()
    setCookie(ACC_SEARCH_STATUS, statusCode)
    setCookie(ACC_SEARCH_PRIORITY, priorityCode)
    setCookie(ACC_SEARCH_TEXT, searchText)
    setCookie(ACC_SEARCH_API, searchAPI)
    setCookie(ACC_SEARCH_CUSTOMER, searchCustomer)
    setCookie(ACC_SEARCH_TYPE, searchTypeAcc)
}

export function getAccSearchCookie() {
    return {
        [ACC_SEARCH_STATUS]: getCookie(ACC_SEARCH_STATUS),
        [ACC_SEARCH_PRIORITY]: getCookie(ACC_SEARCH_PRIORITY),
        [ACC_SEARCH_TEXT]: getCookie(ACC_SEARCH_TEXT),
        [ACC_SEARCH_API]: getCookie(ACC_SEARCH_API),
        [ACC_SEARCH_CUSTOMER]: getCookie(ACC_SEARCH_CUSTOMER),
        [ACC_SEARCH_TYPE]: getCookie(ACC_SEARCH_TYPE),

    }
}

export function clearAccSearchCookie() {
    removeCookie(ACC_SEARCH_STATUS)
    removeCookie(ACC_SEARCH_PRIORITY)
    removeCookie(ACC_SEARCH_TEXT)
    removeCookie(ACC_SEARCH_API)
    removeCookie(ACC_SEARCH_CUSTOMER)
    removeCookie(ACC_SEARCH_TYPE)

}

export function getIsNpi() {
    return getCookie(IS_NPI)
}

export function getIsPlanning() {
    return getCookie(IS_PLANNING)
}

export function getIsSale() {
    return getCookie(IS_SALE)
}

export function setUrlIncoming(data) {
    setCookie(URL_INCOMING, data)
}
export function getUrlIncoming() {
    return getCookie(URL_INCOMING)
}


// WEBPACK FOOTER //
// ./src/lib/auth.js